import { axiosRequest } from '@/util/axios-request'

// 官方文件—PND1列表查询
export const taxGetMonthList = data =>
  axiosRequest({
    url: '/web/tax/getMonthList',
    method: 'POST',
    data
  })

// 官方文件—PND1下载Excel
export const taxExportMonth = data =>
  axiosRequest({
    url: '/web/tax/exportMonth',
    method: 'POST',
    data
  })

// 官方文件—PND1下载TXT
export const downloadPNDTxt = data =>
  axiosRequest({
    url: '/web/tax/exportMonthTxt',
    method: 'POST',
    data
  })

// 官方文件—PND1下载pdf
export const downloadPdf = data =>
  axiosRequest({
    url: '/web/tax/download',
    method: 'POST',
    params: data
  })

// 官方文件—PND3列表查询
export const getPnd3MonthList = data =>
  axiosRequest({
    url: '/web/tax/getPnd3MonthList',
    method: 'POST',
    data
  })

// 官方文件—PND3下载TXT
export const downloadPnd3TXT = data =>
  axiosRequest({
    url: '/web/tax/exportPnd3Txt',
    method: 'POST',
    data
  })

// 官方文件—PND3下载Excel
export const exportPnd3Excel = data =>
  axiosRequest({
    url: '/web/tax/exportPnd3Excel',
    method: 'POST',
    data
  })

// 官方文件—PND3下载pdf
export const downloadPnd3PDF = data =>
  axiosRequest({
    url: '/web/tax/downloadPnd3',
    method: 'POST',
    data
  })

// 官方文件—PND1 Kor 列表查询
export const getKorLists = data =>
  axiosRequest({
    url: '/web/tax/getKorLists',
    method: 'POST',
    data
  })

// 官方文件—PND1 Kor Excel下载
export const exportKorExcel = data =>
  axiosRequest({
    url: '/web/tax/exportKorExcel',
    method: 'POST',
    data
  })

// 官方文件—PND1 Kor 下载TXT
export const downloadKorTxt = data =>
  axiosRequest({
    url: '/web/tax/exportKorTxt',
    method: 'POST',
    data
  })

// 官方文件—PND1 Kor 下载pdf
export const downloadKorPdf = data =>
  axiosRequest({
    url: '/web/tax/downloadKorPdf',
    method: 'POST',
    data
  })

// 官方社保文件-SorPorSor.1-10-查询
export const SocialGetMonthList = data =>
  axiosRequest({
    url: '/web/Social/getMonthList',
    method: 'POST',
    data
  })
// 官方社保文件-SorPorSor.1-10-txt导出
export const downloadMonthTxt = data =>
  axiosRequest({
    url: '/web/social/exportMonthTxt',
    method: 'POST',
    data
  })
// 官方社保文件-SorPorSor.1-10-Excel导出
export const socialExportMonth = data =>
  axiosRequest({
    url: '/web/Social/exportMonth',
    method: 'POST',
    data
  })
// 员工信息表
export const staffInfoList = data =>
  axiosRequest({
    url: 'web/staff_info/getList',
    method: 'POST',
    data
  })
// 员工信息Excel
export const staffInfoExcel = data =>
  axiosRequest({
    url: '/web/staff_info/export',
    method: 'POST',
    data
  })

// 员工信息Excel
export const exportMonth = data =>
  axiosRequest({
    url: '/web/provident/exportMonth',
    method: 'POST',
    data
  })

//
export const getMonthList = data =>
  axiosRequest({
    url: '/web/provident/getMonthList',
    method: 'POST',
    data
  })

// 50tawi下载pdf
export const downloadTawiPdf = data =>
  axiosRequest({
    url: '/web/Certificate/download50Tawi',
    method: 'POST',
    data
  })

// 员工证明——50Tawi 全部发送
export const send50Tawi = data =>
  axiosRequest({
    url: '/web/Certificate/send50Tawi',
    method: 'POST',
    data
  })

// 员工证明——在职证明、工资证明、就业证明列表
export const certificateLists = data =>
  axiosRequest({
    url: '/web/Certificate/lists',
    data
  })
// 员工证明——在职证明、工资证明、就业证明发送邮件
export const certificateSend = data =>
  axiosRequest({
    url: '/web/Certificate/send',
    data
  })

// 员工证明——在职证明、工资证明、就业证明批量下载
export const certificateDown = data =>
  axiosRequest({
    url: '/web/Certificate/download',
    data
  })

// 获取员工证明类型
export const certificateInit = data =>
  axiosRequest({
    url: '/web/certificate/init',
    data
  })

// 证明下载——50tawi员工列表
export const getTawiList = data =>
  axiosRequest({
    url: '/web/Certificate/getTawiList',
    data
  })

// 证明下载——获取员工空邮箱的数量
export const countNoEmail = data =>
  axiosRequest({
    url: '/web/Certificate/countNoEmail',
    data
  })

// 证明下载——批量发送邮件
export const sendTawiMail = data =>
  axiosRequest({
    url: '/web/Certificate/sendMail',
    data
  })

// 证明下载——预览
export const previewTawi = data =>
  axiosRequest({
    url: '/web/Certificate/previewTawi',
    data
  })

// 模板配置—获取证明模板配置
export const getCertificateConfig = data =>
  axiosRequest({
    url: '/web/company/getCertificateConfig',
    method: 'GET',
    params: data
  })

// 模板配置—保存通用模板配置
export const saveBasicCertificateConfig = data =>
  axiosRequest({
    url: '/web/company/saveBasicCertificateConfig',
    method: 'GET',
    params: data
  })

// 模板配置—保存官方文件配置
export const saveOfficialCertificateConfig = data =>
  axiosRequest({
    url: '/web/company/saveOfficialCertificateConfig',
    method: 'GET',
    params: data
  })

// 模板配置—保存员工模板配置
export const saveCertificateConfig = data =>
  axiosRequest({
    url: '/web/company/saveCertificateConfig',
    method: 'GET',
    params: data
  })

// 历史记录——列表查询
export const getHistoryList = data =>
  axiosRequest({
    url: '/web/Certificate/certificateHistory',
    method: 'GET',
    params: data
  })

// 定时任务—新建定时任务
export const addCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/addTask',
    method: 'GET',
    params: data
  })

// 定时任务—编辑定时任务
export const editCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/editTask',
    method: 'GET',
    params: data
  })

// 定时任务—取消定时任务
export const cancelCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/cancelTask',
    method: 'GET',
    params: data
  })

// 定时任务——列表查询
export const getCertificateList = data =>
  axiosRequest({
    url: '/web/Certificate/taskList',
    method: 'GET',
    params: data
  })

// 定时任务——任务详情
export const infoCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/taskInfo',
    method: 'GET',
    params: data
  })

// 定时任务——发送记录列表查询
export const sendCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/taskSendList',
    method: 'GET',
    params: data
  })

// 定时任务—重新发送失败记录
export const retryCertificateTask = data =>
  axiosRequest({
    url: '/web/Certificate/retrySendFailTask',
    method: 'GET',
    params: data
  })

// 定时任务—检测任务名是否重复
export const existTaskName = data =>
  axiosRequest({
    url: '/web/Certificate/existTaskName',
    method: 'GET',
    params: data
  })

// 员工证明—获取任务发送记录失败数量
export const getTaskFailTotal = data =>
  axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  })

export const downloadList = data =>
  axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  })

export const deleteApi = data =>
  axiosRequest({
    url: '/web/Certificate/getTaskFailTotal',
    method: 'GET',
    params: data
  })
